import { ThemeProvider, theme } from '@primer/react';
import { AuthProvider } from 'oidc-react';
import { useEffect, useMemo } from 'react';
import 'react-loading-skeleton/dist/skeleton.css';
import { useDispatch, useSelector } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import BaseStyles from './BaseStyles';
import LoaderPage from './components/loader-page';
import AuthorizedContent from './content/AuthorizedContent';
import SigoutContent from './content/SigoutContent';
import UnAuthorizedContent from './content/UnAuthorizedContent';
import { CommonProvider } from './contexts/common';
import { actions } from './state/actions/actionsWrapper';
import { localizedResourceAction } from './state/actions/localized-resource/localizedResourceAction';
import { RootState } from './state/reducers';
import { eAccountReducerStatus } from './state/reducers/authReducer';
import { HubProvider } from './contexts/HubProvider';
import { AcceptanceFormPage } from './pages';
import SurveyFormGoLivePage from './pages/crm-survey-form/SurveyFormGoLivePage';
import deepmerge from 'deepmerge';


const customTheme = deepmerge({
  ...theme,
  fontSizes: ['11px', '13px', '16px', '20px', '24px', '32px', '40px', '48px', '56px'],
  radii: ["4px", "6px", "8px", "12px"]
},
  {

    colorSchemes: {
      light: {
        colors: {
          accent: {
            fg: "#0969da",
            emphasis: "#0969da"
          },
          btn: {
            bg: "#fff",
            primary: {
              bg: "#0969da",
              focusBg: "#0969da",
              hoverBg: "#0969da",
              selectedBg: "#0969da",
              disabledBg: "rgba(84, 174, 255, 0.4)"
            },
          },
          primer: {
            border: {
              active: "#0969da"
            }
          }

        }
      }
    }
  })

function App() {
  const { user_info, status, isSignOuted } = useSelector((x: RootState) => x.auth)
  const { language } = useSelector((x: RootState) => x.common)
  const { appConfig } = useSelector((x: RootState) => x.appConfig)
  const path = window.location.pathname;
  const publicPath: string[] = ["/acceptance-form", "/crm_survey_register"];

  const parsedCrmParams = useMemo(() => {
    let dm_chiendich_id = 0;
    let crm_survey_form_id = 0;
    let uuid: string | null = null;

    if (path.includes('/crm_survey_register')) {
      const rawSegments = path
        .substring(path.indexOf('/crm_survey_register') + '/crm_survey_register'.length)
        .split('/')
        .filter(s => s.length > 0);

      if (rawSegments.length > 0) {
        const lastParam = rawSegments[rawSegments.length - 1];
        if (lastParam && lastParam.length === 32) {
          uuid = lastParam;
          rawSegments.pop();
        }
      }

      const numericSegments = rawSegments
        .filter(p => /^\d+$/.test(p))
        .map(p => parseInt(p, 10));

      if (numericSegments.length === 1) {
        dm_chiendich_id = numericSegments[0];
      } else if (numericSegments.length >= 2) {
        dm_chiendich_id = numericSegments[0];
        crm_survey_form_id = numericSegments[1];
      }
    }

    return { dm_chiendich_id, crm_survey_form_id, uuid };
  }, [path]);

  const { dm_chiendich_id, crm_survey_form_id, uuid } = parsedCrmParams;
  const isPublicPage = useMemo(() => {
    return publicPath.some(value => path.includes(value))
  }, [path, publicPath])


  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(localizedResourceAction.loadStart(language))
  }, [language])
  useEffect(() => {
    dispatch(actions.appConfig.loadStart())
  }, [])
  const oidcConfig: any = useMemo(() => {
    if (!appConfig) {
    }
    return {
      onSignIn: (e: any) => {
      },
      authority: appConfig?.OIDC_AUTHORITY,
      clientId: appConfig?.OIDC_CLIENT_ID,
      redirectUri: appConfig?.OIDC_REDIRECT_URI,
      clientSecret: appConfig?.OIDC_CLIENT_SECRET,

    };
  }, [appConfig])
  useEffect(() => {
    if (localStorage.getItem("access_token")) {
      dispatch(actions.account.getUserStart())
    }
  }, [])

  if (status === eAccountReducerStatus.is_getting_profile) {
    return <LoaderPage />
  }

  return (
    <Router>
      <ThemeProvider theme={customTheme} colorMode={"light"}>
        <BaseStyles>
          <CommonProvider>
            {isPublicPage &&
              <>
                {path.includes("acceptance-form") &&
                  <AcceptanceFormPage />
                }
                {path.includes("crm_survey_register") &&
                  <SurveyFormGoLivePage
                    isAttendance={false}
                    crm_survey_form_id={crm_survey_form_id}
                    dm_chiendich_id={dm_chiendich_id}
                    uuid={uuid}
                  />
                }
              </>
            }
            {!isPublicPage &&
              <>
                {isSignOuted === true &&
                  <AuthProvider {...oidcConfig} >
                    <SigoutContent />
                  </AuthProvider>
                }
                {isSignOuted !== true &&
                  <>
                    {user_info &&
                      // <HubProvider>
                      <AuthorizedContent />
                      // </HubProvider>
                    }
                    {!user_info && <UnAuthorizedContent />}
                  </>
                }
              </>
            }

          </CommonProvider>
        </BaseStyles>
      </ThemeProvider>
    </Router>
  );
}

export default App;
